
import CONSTANTES from '../constantes';
import { takeEvery, call, select, put,all } from 'redux-saga/effects'
import { actionPutOrdenes, actionPutOrden, actionPutDetailOrdenComplete, actionPutRevisarOrden,actionObtenerHistorialOrdenes } from '../acciones/accionesOrdenes';
import {message} from 'antd'
import moment from 'moment';


const getOrdenesAdministrador = (status,fecha) => fetch(`${CONSTANTES.URL_API}/panel/orden/?status=g&fecha=${fecha}`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
  })



const getOrdenesValidador = (status,fecha) => fetch(`${CONSTANTES.URL_API}/panel/orden/?status=${status}&pago=ANTICIPADO&fecha=${fecha}`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
  })


// function* sagasValidador(filtros,fecha) {
//   try {
//     let ordenes = null
//     let [query1, query2, query3] = yield all([
//       call(getOrdenesValidador, "a",fecha),
//       call(getOrdenesValidador, "v",fecha),
//       call(getOrdenesValidador, "s",fecha)
//     ])
//     ordenes = [...query1, ...query2, ...query3]
//     if (filtros) {
//       console.log(ordenes)
//       let results = ordenes.filter(orden => orden.numerodeorden.includes(filtros) || orden.cliente.NOMBRE.includes(filtros)|| orden.fechageneracion.includes(filtros)   );
//       console.log(results)
//       yield put(actionPutOrdenes(results))

//     }
//     else yield put(actionPutOrdenes(ordenes))

//   } catch (error) {
//     console.log(error)
//   }
// }

// function* sagasSurtidor(filtros,fecha) {
//   try {
//     let ordenes = null
//     let [query1, query2, query3, query4] = yield all([
//       call(getOrdenesSurtidor, "v",fecha),
//       call(getOrdenesSurtidor, "s",fecha),
//       call(getOrdenesSurtidor, "i",fecha),
//       call(getOrdenesSurtidorCredito, "v",fecha)
//     ])
//     ordenes = [...query1, ...query2, ...query3, ...query4]
//     if (filtros) {
//       console.log(ordenes)
//       let results = ordenes.filter(orden => orden.numerodeorden.includes(filtros) || orden.cliente.NOMBRE.includes(filtros)|| orden.fechageneracion.includes(filtros)  );
//       yield put(actionPutOrdenes(results))
//     }
//     else yield put(actionPutOrdenes(ordenes))

//   } catch (error) {
//     console.log(error)
//   }
// }
const getOrdenesSurtidor = (page,filtros) => fetch(`${CONSTANTES.URL_API}/panel/new_filters_orders/?page=${page}&${filtros}`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
  })

function* sagasSurtidor(page,filtros) {
  try {
    console.log('FILTROS SURTIDOR', filtros)
    // const date=`status_orden=v&search=${moment().format('2021-04')}`
    // console.log('FECHA SURTIDOR', date)
    let ordenes
    if(filtros && filtros.length>0){
      ordenes = yield call(getOrdenesSurtidor, page, filtros);
    }
    else{
      ordenes = yield call(getOrdenesSurtidor, page, 'status_orden=a');
    }
    if (ordenes) {
      yield put(actionPutOrdenes(ordenes.results,ordenes.count))
    }

  } catch (error) {
    console.log(error)
  }
}

function* sagasValidador(page,filtros) {
  try {
    console.log('FILTROS VALIDADOR', filtros)
    // console.log(&search=2021-04)
    const date=`&search=${moment().format('YYYY-MM')}`
    console.log('FECHA VALIDADOR', date)
    let ordenes
    if(filtros && filtros.length>0){
      ordenes = yield call(getOrdenesSurtidor, page, filtros);
    }
    else{
      ordenes = yield call(getOrdenesSurtidor, page, 'status_orden=v&tipoorden=ANTICIPADO');
    }
    if (ordenes) {
      yield put(actionPutOrdenes(ordenes.results,ordenes.count))
    }

  } catch (error) {
    console.log(error)
  }
}

function* sagasGetOrdenes(values) {
  try {
    const usuario = yield select(state => state.reducerUsuario.usuario)
    let page=values.page
    let filtros=values.filtro
    let ordenes=null
    let fecha=moment().format('YYYY-MM-DD')
    if(usuario.is_superuser)
    {
      ordenes = yield call(getOrdenesAdministrador, filtros,fecha);
      if(filtros){
        let results = ordenes.filter(orden => orden.numerodeorden.includes(filtros) || orden.cliente.NOMBRE.includes(filtros.toUpperCase())|| orden.fechageneracion.includes(filtros));
        yield put(actionPutOrdenes(results))
      } 
      else yield put(actionPutOrdenes(ordenes)) 
    } 
    else
    {
      if(usuario.user_permissions && usuario.user_permissions.length>0)
      {
        let permisoUsuario=usuario.user_permissions[0].codename
        switch (permisoUsuario) {
          case "surtidor":
            yield* sagasSurtidor(page,filtros)
          break;
          case "validador":
            yield* sagasValidador(page,filtros)    
          break;
          case "cajero":
            console.log("hola cajero")
          break;
          default:
            break;
        }

      }
    }
  } catch (error) {

    console.log(error)
  }
}


const getOrden = (idOrden) => fetch(`${CONSTANTES.URL_API}/panel/ordenCUD/${idOrden}/`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
  })


function* sagasGetOrden(values) {
    try {
      //let token = localStorage.getItem('userToken');
      let idOrden=values.idOrden
      let detail = yield call(getOrden, idOrden);
      console.log(detail)
      if (detail) {
        yield put(actionPutOrden(detail))
      }
    } catch (error) {
  
      console.log(error)
    }
  }


  const getDetailOrdenComplete = (idOrden) => fetch(`${CONSTANTES.URL_API}/panel/ordenDetalleCompleto/${idOrden}/`,
  {
    method: 'GET',
    headers: new Headers({
      //'Authorization': 'Token ' + token,
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
  })

  function* sagasDetailOrdenComplete(values) {
    try {
      let idOrden=values.idOrden
      let detail = yield call(getDetailOrdenComplete, idOrden);
      console.log(detail)
      if (detail) {
        yield put(actionPutDetailOrdenComplete(detail))
      }
    } catch (error) {
  
      console.log(error)
    }
  }


  
const RevisarOrden=(idOrden,usuario)=> fetch(`${CONSTANTES.URL_API}/panel/ordenCUD/${idOrden}/`,
{
  method: 'PATCH',
  body:JSON.stringify(usuario),
  headers: new Headers({
    'Content-Type': 'application/json'
})
})
.then(response=>{
    return response.json()
  })
  .catch(e=>{
    console.log(e)
  })

  
const getOrdenLista = (idOrden) => fetch(`${CONSTANTES.URL_API}/panel/orden/${idOrden}/`,
{
  method: 'GET',
  headers: new Headers({
    //'Authorization': 'Token ' + token,
    'Content-Type': 'application/json'
  })
})
.then(response => response.json())
.catch(e => {
})

  function* sagasRevisarOrden(values) {
    try {
      let orden=values.values
      let ordenEdit=yield call(RevisarOrden, orden.id, orden)
      
      if(ordenEdit){
        let ordeneditada=yield call(getOrdenLista, ordenEdit.id)
        console.log(ordeneditada)
        yield put(actionPutRevisarOrden(ordeneditada))
        message.success("Orden Editada");
      } 
      else{
        message.success("Error al editar Orden");
      }
     
    } catch (error) {
      console.log(error)
    }
  }



  const HistorialOrden=()=> fetch(`${CONSTANTES.URL_API}/panel/historial-orden/`,
  {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => { 
  })

  const HistorialOrdenFilter = (cadena,fecha) => fetch(`${CONSTANTES.URL_API}/panel/historial-orden/?fecha=${fecha}&search=${cadena}`,
  {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {
  })

  const HistorialOrdenFilterFecha = (cadena,fecha) => fetch(`${CONSTANTES.URL_API}/panel/historial-orden/?fecha=${fecha}`,
  {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json'
    })
  })
  .then(response => response.json())
  .catch(e => {

  })

  function* sagasGetHistorial(values) {
    try {
      console.log(values)
      if (values.filter) {
        let historial = yield call(HistorialOrdenFilter, values.filter, values.fecha);
        if (historial) {
          yield put(actionObtenerHistorialOrdenes(historial))
        }
      }
      else if(values.fecha){
        console.log(values.fecha)
        let historial = yield call(HistorialOrdenFilterFecha, null, values.fecha);
        if (historial) {
          console.log(historial)
          yield put(actionObtenerHistorialOrdenes(historial))
        }
      }

      else {
        let historial = yield call(HistorialOrden);
        if (historial) {
          yield put(actionObtenerHistorialOrdenes(historial))
        }
      }
  
    } catch (error) {

      console.log(error)
    }
  }
  


export default function* SagasOrdenes() {
  yield takeEvery(CONSTANTES.GET_ORDENES, sagasGetOrdenes)
  yield takeEvery(CONSTANTES.GET_ORDEN, sagasGetOrden)
  yield takeEvery(CONSTANTES.GET_DETAIL_ORDEN, sagasDetailOrdenComplete)
  yield takeEvery(CONSTANTES.REVISAR_ORDEN, sagasRevisarOrden)
  yield takeEvery(CONSTANTES.GET_HISTORIAL_ORDEN, sagasGetHistorial)

}